import fleetApi from '@/api/fleet.api'

export const fleetService = (function () {
  'use strict'

  /**
   * Devuelve los datos de las flotas
   */
  async function getAll() {
    try {
      const response = await fleetApi.getAll()
      return response.data
    } catch (exception) {
      console.error(exception)
      return false
    }
  }

  /**
   * Devuelve los datos para la tabla del ABM de Grupos
   * @param {*} pageSize
   * @param {*} pageNumber
   * @param {*} headers
   * @param {*} enterpriseIds
   */
  async function findAll(pageSize, pageNumber, headers = false, enterpriseIds) {
    try {
      /*
      if (pageSize > 0 && pageNumber > 0) {
        const response = await fleetApi.findAll(pageSize, pageNumber, headers, enterpriseIds)
        return response.data
      } else {
        return {
          data: [],
          headers: []
        }
      }
      */
      const response = await fleetApi.findAll(undefined, undefined, headers, enterpriseIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return {
        data: [],
        headers: []
      }
    }
  }

  /**
   * Devuelve el total de flotas de la collection para el paginador de la tabla del ABM
   */
  async function getTotal(enterpriseIds) {
    try {
      const response = await fleetApi.getTotal(enterpriseIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return 0
    }
  }

  /**
   * Devuelve un flota con el id enviado como parámetro
   * @param {*} fleetId
   */
  async function getFleet(fleetId) {
    try {
        const response = await fleetApi.getFleet(fleetId)
        return response.data
    } catch (exception) {
        console.log(exception)
        return false
    }
  }

  /**
   * Devuelve los flotas con el id de empresa enviado como parámetro
   * @param {*} enterpriseId 
   */
  async function getFleetsByEnterpriseId(enterpriseId) {
    try {
      const response = await fleetApi.getFleetsByEnterpriseId(enterpriseId)
      return response.data
    } catch (exception) {
      console.error(exception)
      return false
    }
  }

  /**
   * Para validar el nombre
   * Devuelve true si ya está asignado a un flota
   * @param {*} name
   */
  async function validateFleetName(name) {
    try {
      if (name) {
        const response = await fleetApi.validateFleetName(name)
        return response.data
      } else {
        return false
      }
    } catch (exception) {
      console.log(exception)
      return false
    }
  }

  /**
   * Para eliminar un fleet
   */
  async function deleteOne(id) {
    /*
    try {
        const response = await fleetApi.deleteOne(id)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
    */
    const response = await fleetApi.deleteOne(id)
    return response.data
  }

  /**
   * Para eliminación múltiple
   */
  async function deleteMany(ids) {
    /*
    try {
        const response = await fleetApi.deleteMany(ids)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
    */
    const response = await fleetApi.deleteMany(ids)
    return response.data
  }


  /**
   * Crea una nuevo flota en la collection
   * @param {*} fleet
   * @param {*} thingIds
   */
  async function create(fleet, thingIds) {
    /*
    try {
      const response = await fleetApi.create(fleet, thingIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await fleetApi.create(fleet, thingIds)
    return response.data
  }

  /**
   *  Actualiza un flota existente en la collection
   * @param {*} fleet
   * @param {*} thingIds
   */
  async function update(fleet, thingIds) {
    /*
    try {
      const response = await fleetApi.update(fleet, thingIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await fleetApi.update(fleet, thingIds)
    return response.data
  }

  return {
    findAll,
    getTotal,
    getFleet,
    validateFleetName,
    deleteOne,
    deleteMany,
    create,
    update,
    getFleetsByEnterpriseId,
    getAll
  }
})()
